import React, { useEffect, useState } from 'react';
import PriceRange from '../PriceRange';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import CheckList from '../CheckList';
import Tag from '../Tag';
import { categoryList } from '@common/utils/constant';

function FilterPanel({ classname, filterOption, skusData, applySelectedFilters, preSelectedFilters, closeFilterHandleChange }) {
  const [minMaxResult, setMinMaxResult] = useState({});
  const [sizeList, setSizeList] = useState([]);
  const [collectionNameList, setCollectionNameList] = useState([]);
  const [catTypeList, setCatTypeList] = useState([]);
  const [designsList, setDesignsList] = useState([]);
  const [fabricsList, setFabricsList] = useState([]);
  const [threadCountList, setThreadCountList] = useState([]);

  function findMinMaxPrices(arr) {
    return arr.reduce(
      (acc, obj) => {
        const price = Number(obj.price);
        if (price < acc.minPrice) acc.minPrice = price;
        if (price > acc.maxPrice) acc.maxPrice = price;
        return acc;
      },
      { minPrice: Infinity, maxPrice: -Infinity }
    );
  }

  function getUniqueFlatData(arr, key) {
    const data = arr.flatMap(obj => obj[key].split(','));
    const filteredData = data.filter(value => value.trim() !== ''); // Skip blank values
    return [...new Set(filteredData)]; // Get unique values
  }

  useEffect(() => {
    // if (skusData.length > 0) {
      // }
    setMinMaxResult({ minPrice: 0, maxPrice: 25000 });
    if (Object.keys(filterOption).length > 0) {
      setCollectionNameList(filterOption?.collections);
      setCatTypeList(filterOption?.categories);
      setSizeList(filterOption?.sizes);
      setDesignsList(filterOption?.designs);
      setFabricsList(filterOption?.fabrics);
      setThreadCountList(filterOption?.threadCounts);
    }
    // setCatTypeList(getUniqueFlatData(categoryList, 'name'));
  }, [filterOption]);

  const handleCheckboxChange = (type, value) => {
    if (type === "priceRange") {
      const tempValue = [0, minMaxResult?.maxPrice];
      applySelectedFilters({
        ...preSelectedFilters,
        priceRange: tempValue,
      });
    } else {
      const updatedFilters = preSelectedFilters[type].includes(value)
        ? preSelectedFilters[type].filter(item => item !== value)
        : [...preSelectedFilters[type], value];
      applySelectedFilters({
        ...preSelectedFilters,
        [type]: updatedFilters,
      });
    }
  };

  const getCheckedItems = (type) => {
    return preSelectedFilters[type].reduce((acc, item) => {
      acc[item] = true;
      return acc;
    }, {});
  };

  const hasAnyFilters = () => {
    const { priceRange, ...otherFilters } = preSelectedFilters;
    const isPriceFilterApplied = priceRange[0] !== 0 || priceRange[1] !== minMaxResult?.maxPrice;
    return isPriceFilterApplied || Object.values(otherFilters).some(array => array.length > 0);
  };

  const resetFilters = () => {
    const tempValue = [0, minMaxResult?.maxPrice];
    applySelectedFilters({
      size: [],
      collectionName: [],
      category: [],
      designs: [],
      fabrics: [],
      threadCounts: [],
      priceRange: tempValue,
    });
  };

  const handlePriceChange = (newPriceRange) => {
    applySelectedFilters({
      ...preSelectedFilters,
      priceRange: newPriceRange,
    });
  };

  // console.log('preSelectedFilters', preSelectedFilters);
  return (
    <div className={`bs-filter bg-light ${classname}`}>
      <div className='bs-filter__title-wrap'>
        <div className='bs-filter__title-cont'>
          <button className='bs-btn bs-btn__btn-icon-link'>
            <span className='bs-btn__icon icon icon-filter'></span>
            <span className='bs-btn__btn-text'>filter</span>
          </button>
          <button className="bs-filter__close-btn" onClick={() => closeFilterHandleChange()}>
              <span className='icon icon-close'></span>
            </button>
        </div>
        <div className='bs-filter__top-wrap'>
          <div className='bs-filter__tag-wrap'>
            {Object.keys(preSelectedFilters).map((key) => {
              return preSelectedFilters[key].length > 0 && preSelectedFilters[key].map((item, index) => {
                if (key !== "priceRange") {
                  return (
                    <React.Fragment key={index}>
                      <Tag title={item} onCheckboxChange={(value) => handleCheckboxChange(key, value)} />
                    </React.Fragment>
                  );
                } else if ((preSelectedFilters["priceRange"][0] !== 0 || preSelectedFilters["priceRange"][1] !== minMaxResult?.maxPrice) && index === 0) {
                  return (
                    <React.Fragment key={index}>
                      <Tag title={`Rs. ${preSelectedFilters["priceRange"][0]} - Rs. ${preSelectedFilters["priceRange"][1]}`} onCheckboxChange={(value) => handleCheckboxChange(key, value)} />
                    </React.Fragment>
                  );
                }
              });
            })}
          </div>
          {hasAnyFilters() && (
            <button className='bs-btn bs-btn__btn-icon-link' onClick={resetFilters}>
              <span className='bs-btn__btn-text'>Clear All</span>
            </button>
          )}
        </div>
      </div>
      <div className='bs-filter__body-wrap'>
        <div className='bs-filter__list'>
          <Accordion className='bs-filter__item'>
            <AccordionSummary
              expandIcon={<span className='icon icon-down'></span>}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <h4 className='bs-filter__label'>Price</h4>
            </AccordionSummary>
            <AccordionDetails>
              {Object.keys(minMaxResult).length > 0 && (
                <PriceRange
                  minMaxResult={minMaxResult}
                  handlePriceChange={handlePriceChange}
                  priceVal={preSelectedFilters.priceRange}
                />
              )}
            </AccordionDetails>
          </Accordion>
        </div>
        <div className='bs-filter__list'>
          <Accordion className='bs-filter__item'>
            <AccordionSummary
              expandIcon={<span className='icon icon-down'></span>}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <h4 className='bs-filter__label'>Collections</h4>
            </AccordionSummary>
            <AccordionDetails>
              <CheckList
                data={collectionNameList}
                checkedItems={getCheckedItems('collectionName')}
                onCheckboxChange={(value) => handleCheckboxChange('collectionName', value)}
                groupName={'collections'}
              />
            </AccordionDetails>
          </Accordion>
        </div>
        <div className='bs-filter__list'>
          <Accordion className='bs-filter__item'>
            <AccordionSummary
              expandIcon={<span className='icon icon-down'></span>}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <h4 className='bs-filter__label'>Size</h4>
            </AccordionSummary>
            <AccordionDetails>
              <CheckList
                data={sizeList}
                checkedItems={getCheckedItems('size')}
                onCheckboxChange={(value) => handleCheckboxChange('size', value)}
                groupName={'size'}
              />
            </AccordionDetails>
          </Accordion>
        </div>
        <div className='bs-filter__list'>
          <Accordion className='bs-filter__item'>
            <AccordionSummary
              expandIcon={<span className='icon icon-down'></span>}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <h4 className='bs-filter__label'>Category</h4>
            </AccordionSummary>
            <AccordionDetails>
              <CheckList
                data={catTypeList}
                checkedItems={getCheckedItems('category')}
                onCheckboxChange={(value) => handleCheckboxChange('category', value)}
                groupName={'category'}
              />
            </AccordionDetails>
          </Accordion>
        </div>
        <div className='bs-filter__list'>
          <Accordion className='bs-filter__item'>
            <AccordionSummary
              expandIcon={<span className='icon icon-down'></span>}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <h4 className='bs-filter__label'>Designs</h4>
            </AccordionSummary>
            <AccordionDetails>
              <CheckList
                data={designsList}
                checkedItems={getCheckedItems('designs')}
                onCheckboxChange={(value) => handleCheckboxChange('designs', value)}
                groupName={'designs'}
              />
            </AccordionDetails>
          </Accordion>
        </div>
        <div className='bs-filter__list'>
          <Accordion className='bs-filter__item'>
            <AccordionSummary
              expandIcon={<span className='icon icon-down'></span>}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <h4 className='bs-filter__label'> Fabric Type</h4>
            </AccordionSummary>
            <AccordionDetails>
              <CheckList
                data={fabricsList}
                checkedItems={getCheckedItems('fabrics')}
                onCheckboxChange={(value) => handleCheckboxChange('fabrics', value)}
                groupName={'fabric-type'}
              />
            </AccordionDetails>
          </Accordion>
        </div>
        <div className='bs-filter__list'>
          <Accordion className='bs-filter__item'>
            <AccordionSummary
              expandIcon={<span className='icon icon-down'></span>}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <h4 className='bs-filter__label'>Thread Count</h4>
            </AccordionSummary>
            <AccordionDetails>
              <CheckList
                data={threadCountList}
                checkedItems={getCheckedItems('threadCounts')}
                onCheckboxChange={(value) => handleCheckboxChange('threadCounts', value)}
                groupName={'thread-count'}
              />
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    </div>
  );
}

export default FilterPanel;